import { TableCell } from 'platform-components';
import React from 'react';

import CharBoard from 'common.components/char-board/char-board';
import { Student } from 'common.components/typings';

import './students__student-data-table-cell.scss';

interface Props {
    code: string;
    login?: string | null;
    isSchoolCodeChanged: boolean;
    student: Student;
}

// eslint-disable-next-line complexity
export const StudentDataTableCell = (props: Props) => {
    const { code, isSchoolCodeChanged, student } = props;

    const { login } = student;

    return (
        <>
            <TableCell mix="students__table-student-login">
                <CharBoard charInput={login || '******'} />
            </TableCell>
            <TableCell mix="students__table-school-code">
                <CharBoard changed={isSchoolCodeChanged} charInput={code} />
            </TableCell>
        </>
    );
};
